module.exports = __webpack_public_path__ + "static/media/stofferingen-56.3625ec2a.jpg";